import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';

function Login() {
  const { login } = useAuth();
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [showAdmin, setShowAdmin] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!phone.trim()) { setError('Entrez votre numéro'); return; }
    setLoading(true);
    setError('');
    const result = await login(phone.trim(), password);
    setLoading(false);
    if (result.error) setError(result.error);
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center',
      justifyContent: 'center', padding: '20px', background: '#0a0a0a'
    }}>
      <div style={{ width: '100%', maxWidth: '380px' }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <div style={{ marginBottom: '24px' }}>
            <img
              src="/logo-sunskycamp.png"
              alt="SunSkyCamp logo"
              style={{ height: '80px', display: 'inline-block' }}
            />
          </div>
          <h1 style={{ fontSize: '22px', fontWeight: 800, color: 'white', letterSpacing: '2px' }}>
            GUIDE SMILE
          </h1>
          <p style={{ color: '#666', fontSize: '13px', marginTop: '4px' }}>
            Gestion des Guides Touristiques
          </p>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} style={{
          background: '#1a1a1a', borderRadius: '16px',
          padding: '24px', border: '1px solid #333'
        }}>
          <div style={{ marginBottom: '16px' }}>
            <label style={{ display: 'block', fontSize: '12px', color: '#888', marginBottom: '6px', fontWeight: 500 }}>
              Numéro de téléphone
            </label>
            <input
              type="tel"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              placeholder="+212 6XX XXX XXX"
              style={{
                width: '100%', padding: '14px 16px', background: '#2a2a2a',
                border: '1px solid #444', borderRadius: '12px', color: 'white',
                fontSize: '16px', outline: 'none'
              }}
            />
          </div>

          {showAdmin && (
            <div style={{ marginBottom: '16px' }} className="animate-in">
              <label style={{ display: 'block', fontSize: '12px', color: '#888', marginBottom: '6px', fontWeight: 500 }}>
                Mot de passe (Admin)
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                style={{
                  width: '100%', padding: '14px 16px', background: '#2a2a2a',
                  border: '1px solid #444', borderRadius: '12px', color: 'white',
                  fontSize: '16px', outline: 'none'
                }}
              />
            </div>
          )}

          {error && (
            <div style={{
              background: '#3B1111', border: '1px solid #E53E3E', borderRadius: '8px',
              padding: '10px', marginBottom: '16px', fontSize: '13px', color: '#FCA5A5'
            }}>
              {error}
            </div>
          )}

          <button type="submit" disabled={loading} style={{
            width: '100%', padding: '14px', background: loading ? '#666' : '#E53E3E',
            color: 'white', border: 'none', borderRadius: '12px',
            fontSize: '16px', fontWeight: 700, cursor: loading ? 'wait' : 'pointer',
            transition: 'background 0.2s'
          }}>
            {loading ? '...' : 'Connexion'}
          </button>

          <button type="button" onClick={() => setShowAdmin(!showAdmin)} style={{
            width: '100%', background: 'none', border: 'none',
            color: '#555', fontSize: '12px', marginTop: '16px',
            cursor: 'pointer', padding: '8px'
          }}>
            {showAdmin ? 'Connexion Guide' : 'Connexion Admin'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login;
